<!-- 予約登録枠数マスタ　月毎更新画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>


<style type="text/css">

	/* 予約枠数が0の場合　背景色設定しない */
	#wwkkr .wkkrListCnt1Under {}
	/* 予約枠数が1以上の場合　背景色設定する */
	#wwkkr .wkkrListCnt1Over {
		background-color: #eCf5e7;
	}
	/* 予約枠数を編集した場合 背景色設定する */
	#wwkkr .wkkrListEdit {
		background-color: #dbf1f4;
		color: #005caf;
		font-size: 1.2rem;
		font-weight: bold;
		border: 2px solid #81C7D4;
	}
	#wwkkr input[type="text"]:focus {
		background-color: #ecd9ec;
		font-size: 1.1rem;
		color: purple;
		border: 2px solid plum;
	}
</style>

<template>
	<div class="contents" id="wwkkr">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>予約登録枠数マスタ</h2>
			<ul class="contntMenu">
				<li class="onReserve" v-on:click="onBulkReserve">期間指定一括登録</li>
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>

			<!-- ▽  -->
			<section class="inputArea">

				<!-- 表示月選択 -->
				<div class="caption">
					<div class="listUp">
						<ul class="dayForm ym">
							<li>
								<select v-model="inputForm.year">
									<option value=0>選択</option>
									<option v-for="item in inputForm.listYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
							</li>
							<li>
								<select v-model="inputForm.month">
									<option value=0>選択</option>
									<option v-for="item in inputForm.listMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
							</li>
							<li>
								<select v-model="inputForm.waku">
									<option value="">選択してください</option>
									<option v-for="item in wakuList" v-bind:value="item.waku" v-bind:key="item.waku">
										{{item.wknm}}
									</option>
								</select>
							</li>
						</ul>
						<button class="changeBtn" v-on:click="onChangeCalender">表示</button>
					</div>
					<dl class="computed">
						<dt>枠管理区分</dt><dd>{{computedStrKrkb}}</dd>
						<dt>カウント方法</dt><dd>{{computedStrCcd1}}</dd>
					</dl>
					<div class="btnLst">
						<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
					</div>
				</div>

			<section class="calendar">
				<!-- 曜日の表示 -->
				<ul class="calendarHeader"><li v-for="day in calender.weekdays" v-bind:key="day">{{day}}</li></ul>

				<!-- 日付、予約状況の表示 -->
				<div v-for="(itemOfDate,i) in calender.displayDates" v-bind:key="itemOfDate.date">
					<dl v-if="calender.wakuData[i].isDisplay">
						<dt>{{calender.displayDates[i]}}</dt>
						<!-- 枠管理区分　時間帯 -->
						<dd v-if="krkb == '2'">
							<ul v-if="calender.wakuData[i].ckbn == '9'">
								<li v-for="(itemOfTmzn,j) in calender.wakuData[i].tmznList" v-bind:key="itemOfTmzn.tmzn">
									<span>{{getZnnm(itemOfTmzn.tmzn)}}</span>
									<input type="text" maxlength="3" placeholder="XXX" v-model="itemOfTmzn.cnt1" v-bind:class="getClassNameByRecordStatusesOfTime(i,j)" v-on:change="changeRecordOfTime(i,j)">
								</li>
							</ul>
						</dd>
						<!-- 枠管理区分　日 -->
						<dd v-else >
							<input type="text" maxlength="3" placeholder="XXX" v-model="calender.wakuData[i].cnt1" v-bind:class="getClassNameByRecordStatusesOfDate(i)" v-on:change="changeRecordOfDate(i)" v-if="calender.wakuData[i].ckbn == '9'">
						</dd>
					</dl>
				</div>
			</section>

			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { WWKKRApi } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWWKKR',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			ModalWindow: ModalWindow
		},
		data() {
			return {
				// 入力フォーム
				inputForm: {

					// 年のプルダウン内容
					listYear:[],

					// 年
					year: 0,

					// 月のプルダウン内容
					listMonth: [
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
					],

					// 月
					month: 0,

					// 枠
					waku: ''
				},

				// 枠
				waku: '',

				// 枠管理区分
				krkb: '',

				// カウント方法
				ccd1: '',

				// 予約枠プルダウン用リスト
				// waku: 予約枠
				// wknm: 予約枠名称
				// krkb: 枠管理区分（1:日 2:時間）
				// ccd1: カウント方法（1:実人数、2:延人数）
				wakuList: [],

				// 予約登録枠数管理マスタ　時間帯枠
				// tmzn:  時間帯
				// date: 予約日（YYYY/MM/DD）
				// cnt1:  枠数
				// recordStatus: レコードステータス
				// 0: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
				//    ともに存在する
				// 1: WCALM（休業日マスタ）は存在するが
				//    WWKKR（予約登録枠マスタ）が存在しない
				// 12: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
				//    ともに存在する時、
				//    画面でWIRKM（コース毎検査項目マスタ）を更新する場合
				// 13: WCALM（休業日マスタ）は存在するが
				//    WWKKR（予約登録枠マスタ）が存在しない時、
				//    画面でWWKKR（予約登録枠マスタ）を追加する場合
				wkkrListOfTime: [],

				// 予約登録枠数管理マスタ　日枠
				// date: 予約日（YYYY/MM/DD）
				// cnt1:  枠数
				// recordStatus: レコードステータス
				// 0: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
				//    ともに存在する
				// 1: WCALM（休業日マスタ）は存在するが
				//    WWKKR（予約登録枠マスタ）が存在しない
				// 12: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
				//    ともに存在する時、
				//    画面でWIRKM（コース毎検査項目マスタ）を更新する場合
				// 13: WCALM（休業日マスタ）は存在するが
				//    WWKKR（予約登録枠マスタ）が存在しない時、
				//    画面でWWKKR（予約登録枠マスタ）を追加する場合
				wkkrListOfDate: [],

				// 休業日マスタ
				// date:  日付（YYYY/MM/DD）
				// ckbn:   休業区分
				calmList: [],

				// 時間帯マスタ
				// tmzn:  時間帯コード
				// znnm:  時間帯名
				tmznList: [],

				// 休業日マスタの最小日付と最大日付
				calmData: {
					// 最小日付　年
					minDateYear: 0,
					// 最小日付　月
					minDateMonth: 0,
					// 最小日付　日付
					minDateDate: 0,
					// 最大日付　年
					maxDateYear: 0,
					// 最大日付　月
					maxDateMonth: 0,
					// 最大日付　日付
					maxDateDate: 0
				},

				// 現在時刻
				currentDateTime: {
					// 年
					YYYY: 0,
					// 月
					MM: 0,
					// 日
					DD: 0,
					// 時間
					hh: 0,
					// 分
					mm: 0
				},

				// 現在のカレンダー表示に必要なデータ
				calender: {
					// '日' ～ '土'
					weekdays: ['日', '月', '火', '水', '木', '金', '土'],
					// 表示するカレンダーの年
					year: 0,
					// 表示するカレンダーの月
					month: 0,
					// 前の月、次の月リンクの表示非表示
					// true:表示
					// false:非表示
					flagPreMonth: true,
					flagNextMonth: true,
					// 表示するカレンダーの末尾日付
					monthLastDate: 0,
					// 表示するカレンダーの月の初日の曜日
					firstDayOfWeek: 0,
					// 表示するカレンダーの月の末日の曜日
					lastDayOfWeek: 0,
					// 前月の第５週の表示日（初週に表示）
					preMonthDates: [],
					// 次月の第１週の表示日（初週に表示）
					nextMonthDates: [],
					// カレンダーに表示する日付配列
					displayDates: [],
					// カレンダーに表示する日付配列の行
					// （何週持ってるか）の添え字配列を作成
					displayDatesWeekIndexes: [],
					// カレンダーに表示する日付配列の列
					displayDatesDayIndexes: [0, 1, 2, 3, 4, 5, 6],
					// カレンダー表示用に整形された予約結果配列
					// isDisplay: 表示非表示フラグ
					// ckbn: 休業区分（1:休業日 9:営業日）
					// cnt1: 枠数（枠管理区分:日）
					// recordStatus: レコードステータス（枠管理区分:日）
					// 0: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
					//    ともに存在する
					// 1: WCALM（休業日マスタ）は存在するが
					//    WWKKR（予約登録枠マスタ）が存在しない
					// 12: WCALM（休業日マスタ）とWWKKR（予約登録枠マスタ）が
					//    ともに存在する時、
					//    画面でWIRKM（コース毎検査項目マスタ）を更新する場合
					// 13: WCALM（休業日マスタ）は存在するが
					//    WWKKR（予約登録枠マスタ）が存在しない時、
					//    画面でWWKKR（予約登録枠マスタ）を追加する場合
					// tmznList 
					//  tmzn: 時間帯（枠管理区分:時間）
					//  cnt1: 枠数（枠管理区分:時間）
					//  recordStatus: レコードステータス（枠管理区分:時間）
					wakuData: [],
				},

				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// 算出プロパティ
		computed: {
			// 枠管理区分の文字列を出力（枠プルダウンに依存）
			computedStrKrkb: function() {

				var result = ''

				if ('2' == this.krkb) {
					result = '時間'
				}
				else {
					result = '日'
				}

				return result
			},
			// カウント方法の文字列を出力（枠プルダウンに依存）
			computedStrCcd1: function() {

				var result = ''

				if ('1' == this.ccd1) {
					result = '実人数'
				}
				else {
					result = '延人数'
				}

				return result
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWWKKR::created Start')

			this.firstDisplay();

			UtilityConsoleLog.consoleLog('MasterWWKKR::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog('MasterWWKKR::firstDisplay Start')

				// 非同期通信
				WWKKRApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 年のプルダウン内容
						this.inputForm.listYear = responce.data.listYear

						// 枠
						this.waku = responce.data.waku
						this.inputForm.waku = this.waku
						// 枠管理区分
						this.krkb = responce.data.krkb
						// カウント方法
						this.ccd1 = responce.data.ccd1
						// 予約枠プルダウン用リスト
						this.wakuList = responce.data.wakuList
						// 予約登録枠数管理マスタ　時間帯枠
						this.wkkrListOfTime = responce.data.wkkrListOfTime
						// 予約登録枠数管理マスタ　日枠
						this.wkkrListOfDate = responce.data.wkkrListOfDate
						// 休業日マスタ
						this.calmList = responce.data.calmList
						// 時間帯マスタ
						this.tmznList = responce.data.tmznList
						// 休業日マスタの最小日付と最大日付
						this.calmData = responce.data.calmData
	
						//休業日マスタの最小日付と最大日付
						this.calmData.minDateYear = responce.data.calmData.minDateYear
						this.calmData.minDateMonth = responce.data.calmData.minDateMonth
						this.calmData.minDateDate = responce.data.calmData.minDateDate
						this.calmData.maxDateYear = responce.data.calmData.maxDateYear
						this.calmData.maxDateMonth = responce.data.calmData.maxDateMonth
						this.calmData.maxDateDate = responce.data.calmData.maxDateDate
	
						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm
	
						// 現在のカレンダー表示
						this.calender.year = responce.data.currentDateTime.YYYY
						this.inputForm.year = this.calender.year
						this.calender.month = responce.data.currentDateTime.MM
						this.inputForm.month = this.calender.month
						// 表示するカレンダーの末尾日付
						this.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
						
						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
						// 予約登録枠データの作成
						this.createWakuData()

						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION){
							
							// エラーメッセージ
							var tempErrorMessages = [
								responce.data.errorMessage
							]
							// 入力エラーダイアログを流用する
							this.onValidationErrorModalOpen(tempErrorMessages)

						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
						}

				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWWKKR::firstDisplay End')
				})
			},
			// カレンダー表示月変更
			onChangeCalender: function () {

				UtilityConsoleLog.consoleLog('MasterWWKKR::onChangeCalender Start')

				this.waku = this.inputForm.waku
				this.calender.year = this.inputForm.year
				this.calender.month = this.inputForm.month

				// 非同期通信
				WWKKRApi.ChangeCalender({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					waku: this.waku,
					calenderYear: this.calender.year,
					calenderMonth: this.calender.month
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// レスポンスの受け取り

						// 枠管理区分
						this.krkb = responce.data.krkb
						// カウント方法
						this.ccd1 = responce.data.ccd1

						// 予約登録枠数管理マスタ　時間帯枠
						this.wkkrListOfTime = responce.data.wkkrListOfTime
						// 予約登録枠数管理マスタ　日枠
						this.wkkrListOfDate = responce.data.wkkrListOfDate
						// 休業日マスタ
						this.calmList = responce.data.calmList
						
						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm

						// 表示するカレンダーの末尾日付
						this.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
						
						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()

						// 予約登録枠データの作成
						this.createWakuData()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM){
						// 入力エラーダイアログを流用する
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION){
						
						// エラーメッセージ
						var tempErrorMessages = [
							responce.data.errorMessage
						]
						// 入力エラーダイアログを流用する
						this.onValidationErrorModalOpen(tempErrorMessages)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWWKKR::onChangeCalender End')
				})
			},
			// 更新
			onUpdate: function() {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onUpdate Start')

				// 更新用データの作成
				var tempUpdateData = this.createUpdateData()

				// 非同期通信
				WWKKRApi.Update({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					waku: this.waku,
					calenderYear: this.calender.year,
					calenderMonth: this.calender.month,
					tmzns: tempUpdateData.tmzns,
					dates: tempUpdateData.dates,
					cnt1s: tempUpdateData.cnt1s,
					recordStatuses: tempUpdateData.recordStatuses
				}).then(({ responce }) => {
console.log('1')
					// 更新確認モーダルを閉じる
					this.onConfirmUpdateModalClose()
console.log('2')
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
console.log('3')
						// 予約登録枠数管理マスタ　時間帯枠
						this.wkkrListOfTime = responce.data.wkkrListOfTime
						// 予約登録枠数管理マスタ　日枠
						this.wkkrListOfDate = responce.data.wkkrListOfDate
console.log('4')
						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm
	console.log('5')
						// 現在のカレンダー表示
						//this.calender.year = responce.data.currentDateTime.YYYY
						//this.calender.month = responce.data.currentDateTime.MM
						// 表示するカレンダーの末尾日付
						this.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
		console.log('6')
						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
	console.log('7')
						// 予約登録枠データの作成
						this.createWakuData()
	console.log('8')
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
								console.log('responce error')
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					console.log('catch')
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWWKKR::onUpdate End')
				})
			},
			// 更新用データの作成
			createUpdateData: function() {
			
				var resultTmzns = []
				var resultDates = []
				var resultCnt1s = []
				var resultRecordStatuses = []
				
				if('2' == this.krkb) {
					for(var i=0;i<this.calender.wakuData.length;i++){
						// 時間帯リストの数だけループ
						for(var j=0;j<this.calender.wakuData[i].tmznList.length;j++){
							resultTmzns.push(this.calender.wakuData[i].tmznList[j].tmzn)
							// 前月、次月は空文）
							resultDates.push(this.calender.wakuData[i].date)
							resultCnt1s.push(this.calender.wakuData[i].tmznList[j].cnt1)
							resultRecordStatuses.push(this.calender.wakuData[i].tmznList[j].recordStatus)
						}
					}
				} else {
					for(var i=0;i<this.calender.wakuData.length;i++){
						// 平井Add From
						if(this.calender.wakuData[i].isDisplay) {
						// 平井Add To
							resultTmzns.push('ZZ')
							// 前月、次月は空文）
							resultDates.push(this.calender.wakuData[i].date)
							resultCnt1s.push(this.calender.wakuData[i].cnt1)
							resultRecordStatuses.push(this.calender.wakuData[i].recordStatus)
						}
					}
				}
			
				var resultObject = {
					tmzns: resultTmzns,
					dates: resultDates,
					cnt1s: resultCnt1s,
					recordStatuses: resultRecordStatuses,
				}
			
				return resultObject
			},
			// カレンダーに表示する日付配列の作成
			createDisplayDates: function () {
				
				UtilityConsoleLog.consoleLog('MasterWWKKR::createDisplayDates Start');
			
				// カレンダーに表示する日付配列の行
				// （何週持ってるか）の添え字配列を作成
				var weekLength = this.checkNumWeeksOfDisplayDates()
			
				this.calender.displayDatesWeekIndexes = []
				for (var i = 0; i < weekLength; i++) {
					this.calender.displayDatesWeekIndexes.push(i)
				}
			
				// カレンダーに表示する日付配列の初期化
				this.calender.displayDates = []
				// 作成用の配列
				var tempDisplayDates = []
				// 前月の最大値
				var indexMaxPreMonth = this.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.calender.nextMonthDates.length
			
				// 前月分の日付配列を作成--------------------------------S
				var indexStart = 0
				var indexMax = indexMaxPreMonth
			
				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.calender.preMonthDates[i])
				}
				// 前月分の日付配列を作成--------------------------------E
				// 当月分の日付配列を作成--------------------------------S
				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;
				// 日付配列の値（1～31）
				var valueOfCurrentDate = 1
			
				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(valueOfCurrentDate)
					valueOfCurrentDate++
				}
				// 当月分の日付配列を作成--------------------------------E
				// 次月分の日付配列を作成--------------------------------S
				var indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				var indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth
				// 次月分の日付配列インデックス
				var indexNextMonthDates = 0
			
				// 次月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.calender.nextMonthDates[indexNextMonthDates])
					indexNextMonthDates++
				}
			
				// 次月分の日付配列を作成--------------------------------E
				// カレンダーに表示する日付配列に代入
				this.calender.displayDates = tempDisplayDates
			
				UtilityConsoleLog.consoleLog('MasterWWKKR::createDisplayDates End');
			},
			// カレンダーに表示する日付配列が何週間分の情報を持つべきか返す
			checkNumWeeksOfDisplayDates: function () {
			
				UtilityConsoleLog.consoleLog('MasterWWKKR::checkNumWeeksOfDisplayDates Start');
			
				var numDate = this.calender.firstDayOfWeek
				 + this.calender.monthLastDate
			
				var numWeek = Math.floor((numDate / 7)) + 1
			
				UtilityConsoleLog.consoleLog('MasterWWKKR::checkNumWeeksOfDisplayDates End');
			
				return numWeek
			},
			// 予約登録枠データの作成
			createWakuData: function(){
				var tempWakuData = []

				// 前月の最大値
				var indexMaxPreMonth = this.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.calender.nextMonthDates.length

				// 前月分の日付配列を作成
				var indexStart = 0
				var indexMax = indexMaxPreMonth
			
				for (var i = indexStart; i < indexMax; i++) {
				 tempWakuData.push({
					 isDisplay: false,
					 date: '',
					 ckbn: '0',
					 tmznList:[],
					 cnt1: 0,
					 recordStatus: '9'
				 })
				}

				// 当月分の日付配列を作成

				var objectOfTime = []

				var objectOfDate = {
					cnt1: 0,
					recordStatus: '9'
				}

				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;
			
				// 当月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {

					// 日付
					var tempDate = this.calmList[i - indexStart].date
					// 休業区分
					var tempCkbn = this.calmList[i - indexStart].ckbn

					objectOfTime = []

					objectOfDate = {
						cnt1: 0,
						recordStatus: '0'
					}

					if ('2' == this.krkb) {
						objectOfTime = this.getInfoFromWkkrListOfTime(this.calmList[i - indexStart].date)
					} else {
						objectOfDate = this.getInfoFromWkkrListOfDate(this.calmList[i - indexStart].date)
					}
					tempWakuData.push({
						isDisplay: true,
						date: tempDate,
						ckbn: tempCkbn,
						tmznList: objectOfTime,
						cnt1: objectOfDate.cnt1,
						recordStatus: objectOfDate.recordStatus
					})
				}

				// 次月分の日付配列を作成
				var indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				var indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth

				for (var i = indexStart; i < indexMax; i++) {
				 tempWakuData.push({
					 isDisplay: false,
					 date: '',
					 ckbn: '0',
					 tmznList:[],
					 cnt1: 0,
					 recordStatus: '9'
				 })
				}

				this.calender.wakuData = tempWakuData
			},
			// 予約登録枠数管理マスタ　時間帯枠からデータ取得
			getInfoFromWkkrListOfTime: function(
				in_date) {

				var resultData = []
				var tempData = []

				// 日付でフィルターをかける
				tempData = this.wkkrListOfTime.filter((item)=>{
					return item.date == in_date
				})

				// 時間帯コードの数だけ繰り返す
				for(var i=0;i<this.tmznList.length;i++) {
				
					var tempCnt1 = 0
					var tempRecordStatus = '1'
					
					// 時間帯コードでフィルターをかける
					var tmznData = tempData.filter((item)=>{
						return item.tmzn == this.tmznList[i].tmzn
					})
					
					// レコードが存在すれば設定枠数とステータスを抜き出す
					if(tmznData.length == 1) {
						tempCnt1 = tmznData[0].cnt1
						tempRecordStatus = tmznData[0].recordStatus
					}
					
					resultData.push({
						tmzn: this.tmznList[i].tmzn,
						cnt1: tempCnt1,
						recordStatus: tempRecordStatus
					})
				}

				return resultData
			},
			// 予約登録枠数管理マスタ　日枠からデータ取得
			getInfoFromWkkrListOfDate: function(
				in_date) {

				var tempCnt1 = 0
				var tempRecordStatus = '1'

				// 時間帯コードでフィルターをかける
				var tempData = this.wkkrListOfDate.filter((item)=>{
					return item.date == in_date
				})
				
				var resultData = {
					cnt1: 0,
					recordStatus: '1'
				}
				
				if(tempData.length == 1) {
					resultData.cnt1 = tempData[0].cnt1
					resultData.recordStatus = tempData[0].recordStatus
				}
				else {
					resultData.cnt1 = tempCnt1
					resultData.recordStatus = tempRecordStatus
				}

				
				return resultData
			},
			// 時間帯を時間帯名に変換する
			getZnnm: function (in_tmzn) {

				var result = ''

				for (var i = 0; i < this.tmznList.length; i++) {
					if (in_tmzn == this.tmznList[i].tmzn) {
						result = this.tmznList[i].znnm
					}
				}
				return result;
			},
			// レコードに変更があったとき（枠管理区分:時間）
			changeRecordOfTime: function(index0,index1) {
			
				if('0' == this.calender.wakuData[index0].tmznList[index1].recordStatus){
					this.calender.wakuData[index0].tmznList[index1].recordStatus = '12'
				} else if('1' == this.calender.wakuData[index0].tmznList[index1].recordStatus) {
					this.calender.wakuData[index0].tmznList[index1].recordStatus = '13'
				}
			},
			// レコードに変更があったとき（枠管理区分:日）
			changeRecordOfDate: function(index0) {
			
				if('0' == this.calender.wakuData[index0].recordStatus){
					this.calender.wakuData[index0].recordStatus = '12'
				} else if('1' == this.calender.wakuData[index0].recordStatus) {
					this.calender.wakuData[index0].recordStatus = '13'
				}
			},
			// recordStatus、cnt1によってクラスを設定する（枠管理区分:時間）
			getClassNameByRecordStatusesOfTime: function(index0,index1) {
			
				var resultClassName = ''
			
				if('12' == this.calender.wakuData[index0].tmznList[index1].recordStatus
					|| '13' == this.calender.wakuData[index0].tmznList[index1].recordStatus){
					resultClassName = 'wkkrListEdit'
				} else if(this.calender.wakuData[index0].tmznList[index1].cnt1 > 0){
					resultClassName = 'wkkrListCnt1Over'
				} else {
					resultClassName = 'wkkrListCnt1Under'
				}
			
				return resultClassName
			},
			// recordStatus、cnt1によってクラスを設定する（枠管理区分:日）
			getClassNameByRecordStatusesOfDate: function(index0) {
			
				var resultClassName = ''
			
				if('12' == this.calender.wakuData[index0].recordStatus
					|| '13' == this.calender.wakuData[index0].recordStatus){
					resultClassName = 'wkkrListEdit'
				} else if(this.calender.wakuData[index0].cnt1 > 0){
					resultClassName = 'wkkrListCnt1Over'
				} else {
					resultClassName = 'wkkrListCnt1Under'
				}
			
				return resultClassName
			},
			// 期間一括登録画面
			onBulkReserve: function () {
				UtilityConsoleLog.consoleLog("MasterWWKKR::onBulkReserve Start")

				this.$router.push("/MasterWWKKRBulk")

				UtilityConsoleLog.consoleLog("MasterWWKKR::onBulkReserve End")
			},
			// メニューへ戻る
			onBack: function () {
				UtilityConsoleLog.consoleLog("MasterWWKKR::onBack Start")

				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog("MasterWWKKR::onBack End")
			},
			// 更新ボタン押下時（更新ダイアログを開く前）
			validationOnUpdate: function(){
			
				UtilityConsoleLog.consoleLog('MasterWWKKR::validationOnUpdate Start')
				
				// フロント用エラーメッセージ
				var resultErrorMessages = []
				
				// 枠数の数値チェック
				if('2' == this.krkb){

					for(var i=0;i<this.calender.wakuData.length;i++){
						for(var j=0;j<this.calender.wakuData[i].tmznList.length;j++){
							var tempDate = this.calender.wakuData[i].date
							var tempZnnm = this.getZnnm(this.calender.wakuData[i].tmznList[j].tmzn)
							var tempNum = this.checkNumber(this.calender.wakuData[i].tmznList[j].cnt1)
							if (tempNum == -1) {
								resultErrorMessages.push( tempDate + 'の時間帯:' + tempZnnm + 'の枠数が整数値で入力されていません。')
							}
						}
					}
				} else {
					for(var i=0;i<this.calender.wakuData.length;i++){
						var tempDate = this.calender.wakuData[i].date
						var tempNum = this.checkNumber(this.calender.wakuData[i].cnt1)
						if (tempNum == -1) {
							resultErrorMessages.push( tempDate + 'の' + tempZnnm + 'の枠数が整数値で入力されていません。')
						}
					}
				}
				
				UtilityConsoleLog.consoleLog('MasterWWKKR::validationOnUpdate End')
				
				return resultErrorMessages
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWWKKR::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWWKKR::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWWKKR::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWWKKR::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWWKKR::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWWKKR::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onConfirmUpdateModalOpen Start')

				// フロント用エラーメッセージ
				var tempErrorMessages = []
				// 入力チェック
				var tempErrorMessages = this.validationOnUpdate()

				// 一件でもエラーがあれば入力エラーモーダルウィンドウを開き、処理を中断する
				if( tempErrorMessages.length > 0 ){
					this.onValidationErrorModalOpen(tempErrorMessages)
					return
				}

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWWKKR::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWWKKR::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWWKKR::onConfirmUpdateModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWWKKR::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWWKKR::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWWKKR::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWWKKR::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Master/WWKKR/MasterWWKKR.vue